import React from 'react'

import NavBar from '../Header/NavBar'

import AllSections from './AllSections'
import SliderAutoPlay from '../Slider/SliderAutoPlay'
// import MenuforWeb from '../Menu/MenuforWeb'

export default function Home() {
  return (

    <>
      <div className='z-0 w-full'>


        <div > <NavBar /></div>


        {/* <div className='absolute flex justify-center items-center flex-col w-full h-full z-40 bg-transparent '>

          <h1 className=' font-bold text-center bg-black z-50 bg-opacity-50 p-4 rounded-lg text-5xl text-white'>  SOUTH GLOBAL EXIM <span className='opacity-60'> Welcomes You! </span> </h1>

          <p className='bg-transparent md:w-[60%] text-[22px] text-center text-white  px-2'> Bringing you the finest spices, dried chili, seeds, and turmeric with a commitment to quality and sustainability. Experience authentic flavors and a journey toward a better, more natural world! 🌿✨ </p>



        </div> */}


        <div className=' h-full  bg-gray-500'>
          {/* <div className='bg-black absolute h-screen w-full z-10 bg-opacity-50'> </div> */}
          <div className='z-10 w-full'> <SliderAutoPlay /> </div>
        </div>




      </div>

      <AllSections />



    </>
  )
}
